export default {
  title: '求职者状态管理',
  menu: '求职者状态管理',
  label: {
    editCandidateStatus: '编辑求职者状态',
    addCandidateStatus: '新增求职者状态',
    status: '求职者状态',
    causeCN: '中文状态评论',
    causeEN: '英文状态评论',
    enabled: '激活',
    disabled: '禁用',
    cnName: '求职者状态中文名称',
    enName: '求职者状态英文名称',
    statusEnableLabel: '状态'
  },
  placeholder: {
    status: '请选择求职者状态',
    causeCN: '请输入中文状态评论',
    causeEN: '请输入英文状态评论',
    keywords: '关键字搜索'
  },
  message: {
    deleteCandidateStatus: '您确定要删除 {status}-{cause} 么?',
    updateStatusSuccess: '更新状态成功',
    saveStatusSuccess: '保存状态成功'
  }
}
